import { Injectable } from '@angular/core';
import { IBackendErrorData } from '../fi-backend/fi-backend.service';
import { StatusCodeType } from '../types';
import { ActionFailureReasonCode } from '../types/action-failed-reason-code';
import { FiDialogsService } from '../fi-dialogs';
import { AppTextService } from '../app-text';
import { MagicLinkDeliveryType } from '@fi-shared/types/magic-link-delivery-type';

@Injectable()
export class FiAuthenticateHelperService {
    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    handleInvalidMagicLink(
        err: IBackendErrorData,
        opts: {
            requestNewMagicLinkFn: () => Promise<any>;
        },
    ) {
        if (
            err &&
            err.status == StatusCodeType.BadRequest &&
            err.error &&
            (err.error.Reason === ActionFailureReasonCode.User_MagicLinkExpired ||
                err.error.Reason === ActionFailureReasonCode.User_MagicLinkUsed)
        ) {
            this.fiDialogsService
                .confirm({
                    headerText: this.appTextService.get('magic_link.expired_header'),
                    messageText: this.appTextService.get('magic_link.expired_message'),
                    yesButtonText: this.appTextService.get('magic_link.request_new_link'),
                })
                .onYesButtonClick(() => {
                    opts.requestNewMagicLinkFn().then(() => this.showMagicLinkResentDialog());
                });
        } else {
            this.fiDialogsService.error({
                headerText: this.appTextService.get('common.oops'),
                messageText: this.appTextService.get('error_message.magic_link_not_valid'),
            });
        }
    }

    showMagicLinkSentDialog(userContact: string, deliveryType: MagicLinkDeliveryType) {
        const messageTextId =
            deliveryType === MagicLinkDeliveryType.Sms
                ? 'common.magic_link_sent_sms_text'
                : 'common.magic_link_sent_email_text';
        this.fiDialogsService.notify({
            headerText: this.appTextService.get('common.magic_link_resent_header'),
            messageText: this.appTextService.get(messageTextId, { '{0}': userContact }),
            headerIconClass: 'fa-regular fa-arrow-rotate-right BrandedColor',
            isTopCloseButtonShown: true,
            isNoButtonHidden: true,
            config: {
                panelClass: 'fi-rounded-dialog-panel',
            },
        });
    }

    showMagicLinkResentDialog() {
        this.fiDialogsService.notify({
            headerText: this.appTextService.get('common.magic_link_resent_header'),
            messageText: this.appTextService.get('common.magic_link_resent_text'),
            isNoButtonHidden: true,
        });
    }

    handleUserLoginNumber(login: string): string {
        if (login.startsWith('(+')) {
            let [countryCode, contactValue]: string[] = login.split(')');
            if (contactValue.trim().startsWith('0')) {
                return countryCode + ') ' + contactValue.trim().substr(1);
            }
        }
        return login;
    }
}
